import { QuizStats } from "../../../../context/QuizContext";
import NumberButton from "./NumberButton";

function ProgressDetails({ isMobile }) {
    const {
        visitedNumber,
        numberOfQuestions,
        answeredNumber,
        notAnsweredNumber,
    } = QuizStats();

    if (isMobile) return null;

    return (
        <div className="px-4 py-6 bg-white shadow-lg rounded-xl">
            <p className="font-bold text-center text-md md:text-xl mb-7 text-blue-color-primary">
                عدد الأساله : <span>{numberOfQuestions}</span>
            </p>
            <ul className="flex items-center justify-evenly">
                <li className="flex flex-col items-center">
                    <p className="mb-2 font-medium text-gray-color-primary">
                        لم يشاهد
                    </p>
                    <NumberButton disabled={true} color="bg-gray-color-light">
                        {numberOfQuestions - visitedNumber || 0}
                    </NumberButton>
                </li>
                <li className="flex flex-col items-center">
                    <p className="mb-2 font-medium text-gray-color-primary">
                        غير مجاب
                    </p>
                    <NumberButton disabled={true} color="bg-red-color-primary">
                        {notAnsweredNumber}
                    </NumberButton>
                </li>
                <li className="flex flex-col items-center">
                    <p className="mb-2 font-medium text-gray-color-primary">
                        مجاب
                    </p>
                    <NumberButton disabled={true} color="bg-green-color">
                        {answeredNumber}
                    </NumberButton>
                </li>
            </ul>
        </div>
    );
}

export default ProgressDetails;
